module.exports = __webpack_public_path__ + "static/media/27OCHA15.3b0926f8.jpg";